import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import {
  deleteAppointment,
  HistoryAppointment,
  SaveApiResMessage,
} from '@/actions';
import Modal from '@/ctComponents/Modal';
import { useNotify } from 'react-admin';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import Card from './Card';
import AppointmentHistory from './AppointmentHistory';

const BookedCard = ({
  data,
  setAppointmentSet,
  containerId,
  selectedStatus,
  terminalId,
  container,
}) => {
  const notify = useNotify();
  const [show, setShow] = useState(false);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const showHistory = () => {
    setLoadingHistory(true);
    HistoryAppointment(containerId, data[0].terminalId)
      .then((res) => {
        noScroll();
        setHistory(res.data.appointments);
        setLoadingHistory(false);
      })
      .catch((err) => {
        notify(err, 'warning');
        setLoadingHistory(false);
      });
  };
  const handleCancel = () => {
    setLoading(true);
    removeNoScroll();

    deleteAppointment({ id: data[0]?.id, selectedStatus: selectedStatus })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res?.message,
          mode: 'success',
        });
        setAppointmentSet((prev) => {
          const newState = {
            ...prev,
            [terminalId.replace('key_', '')]: {
              ...prev[terminalId.replace('key_', '')],
              status: 'PENDING_CANCEL',
              statusText: 'Canceling',
            },
          };
          return newState;
        });
        setShow(false);
        setLoading(false);
      })
      .catch((err) => {
        setShow(false);
        SaveApiResMessage({
          title: 'Error',
          message: err?.message || 'Cancel failed',
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  return (
    <>
      <Card
        terminal={data[0]?.terminal?.replace(/\s+/g, '')}
        date={data[0]?.date?.replace(/(\d{4})-(\d{2})-(\d{2})/, '$2/$3/$1')}
        time={data[0]?.time}
        license_plate={data[0]?.license_plate}
        type={data[0]?.type === 'SINGLE' ? 'Single' : 'Dual'}
        status={data[0]?.status}
        statusText={data[0]?.statusText}
        lastCheckedAt={data[0]?.lastCheckedAt}
        fromAutobook={data[0]?.fromAutobook}
        lastMessage={data[0]?.lastMessage}
        originSource={data[0]?.origin_source}
        strong_fit={data[0]?.strong_fit}
        width={'fit-content'}
        terminalId={terminalId.replace('key_', '')}
        tooltipSuffix={`root`}
        data={data}
        history={history}
        loadingHistory={loadingHistory}
        showHistory={showHistory}
        setShow={setShow}
      />

      {createPortal(
        <Modal
          show={show}
          children={
            <span
              style={{ textAlign: 'center', width: '100%', marginTop: '24px' }}>
              Are you sure you want to cancel your appointment?
            </span>
          }
          submitText={'Yes, Cancel'}
          icon={'cancelCalendar'}
          title={'Cancel'}
          setShow={setShow}
          submit={handleCancel}
          loadingbutton={loading}
        />,
        document.body
      )}
      <AppointmentHistory
        show={history?.length > 0}
        container={container}
        history={history}
        terminalId={terminalId}
        onClose={() => setHistory([])}
        strong_fit={data[0]?.strong_fit}
      />
    </>
  );
};

export default BookedCard;
